(function($){

var ga_category = 'search_content';

const facetedSearch = {

  /*  Returns height of the search results element
   */
  getSearchResultsHeight: function() {
    return Math.max(800, $('.j-resultsContainer').height());
  },

  /*  Switch search type based on change of radio button from UX
   */
  switchSearchType: function(){
    $(".j-searchOverlay").css('height', facetedSearch.getSearchResultsHeight);
    $(".j-searchOverlay").show();
    var val = facetedSearch.searchType();
    if(val == 'presentations'){
      $('#nav-search-form').attr('action', '/search/user');
    }
    if(val == 'users'){
      $('#nav-search-form').attr('action', '/search/slideshow');
    }
    $('#nav-search-form').submit();
  },

  /*  Submit the form ajax
   */
  ajaxFormSubmit : function(){
    $.getJSON($(this).attr('action'),
        $(this).serialize(),
        facetedSearch.resultResponseHandler);
    return false;
  },

  /*  Initialize facetedSearch. Prepare all the bindings
   */
  init: function(){

    $('#nav-search-query').addClass('focused');

    if(window.location.pathname === '/search/user'){
      ga_category = 'search_people';
      $("#main-nav-mobile-search form").attr('action', '/search/user');
    }
    else if(window.location.pathname === '/search/slideshow'){
      ga_category = 'search_content';
      $("#main-nav-mobile-search form").attr('action', '/search/slideshow');
    }

    $("#search_query").focus();
    // should be 'solr' or 'galene'
    var search_infra = $('.j-searchResults').attr('id');

    var search_source = getUrlVar('searchfrom');

    facetedSearch.trackGA('search_pageload_' + search_infra, search_source);

    //  global event
    facetedSearch.trackGA('search_pageload_global', search_source);

    if($('.searchResults .content-results').length === 0){
      var lbl2;
      // publish a GA event which tells that zero results are loaded
      // check if a filter is applied or not, because we have to bifercate the
      // queries
      if(facetedSearch.searchType() === "presentations") {
        lbl2 = [$('#slideshows_sort').select().val(),
                    $('#slideshows_time').select().val(),
                    $('#slideshows_type').select().val(),
                    $("input[name='ru']:checked").val()
                      ].join('_');
      }
      else {
        lbl2 = [$('.j-userSort').select().val(),
          $('.j-userCountry').select().val(),
          $('.j-userIndustry').select().val(),
          $('.j-userAccount').select().val() ].join('_');
      }
      facetedSearch.trackGA('resultcount_0', lbl2);
    }

    const notice = $('.notice-no-results').html();
    if(notice) {
      if(notice.indexOf("too short") > -1) {
        facetedSearch.trackGA('short_query');
      }
      else if(notice.indexOf("must be shorter") > -1) {
        facetedSearch.trackGA('long_query');
      }
      else if(notice.indexOf("enter a search term") > -1) {
        facetedSearch.trackGA('blank_query');
      }
      else if(notice.indexOf("timed out") > -1) {
        facetedSearch.trackGA('query_timeout');
      }
      else if(notice.indexOf("No SlideShare results") > -1) {
        facetedSearch.trackGA('zero_results');
      }
    }
    if(getUrlVar('utm_source', window.location.href) !== undefined){
      facetedSearch.trackGA('search_pageload_' + search_infra, 'opensearch');
    }

    facetedSearch.spellcheckPageloadHandler();
    $("#search_form").submit(facetedSearch.ajaxFormSubmit);

    facetedSearch.bindClicks();

     // Some legacy stuff !!
    $('.ga-track li a, a.ga-track-sponsored').on('click', function(){
      facetedSearch.trackGA(this.id);
    });

    facetedSearch.getSponsored();

    facetedSearch.trackhighlighting();

    var searchBox = $('#nav-search-form');
    if (['/search/slideshow', '/search/slideshow_ajax'].indexOf(
        $("#search_form").attr('action')) >= 0) {
      var inputTime = $('<input id="filter_time" name="ud" type="hidden"/>');
      var inputType = $('<input id="filter_type" type="hidden" name="ft"/>');
      var inputLang = $('<input id="filter_lang" name="lang" type="hidden"/>');
      var inputSort = $('<input id="filter_sort" name="sort" type="hidden"/>');
      searchBox.append(inputTime, inputType, inputLang, inputSort);

      $("#nav-search-query").focus(function(event) {
        $("#filter_time" ).attr("value",$("#slideshows_time").val());
        $("#filter_type" ).attr("value",$("#slideshows_type").val());
        $("#filter_lang" ).attr("value",$("#slideshows_lang").val());
        $("#filter_sort" ).attr("value",$("#slideshows_sort").val());
      });
    } else {
      var inputSortUsr = $('<input id="filter_sort" name="sort" type="hidden"/>');
      var inputCo = $('<input id="filter_co" name="co" type="hidden"/>');
      var inputIn = $('<input id="filter_in" name="in" type="hidden"/>');
      var inputAt = $('<input id="filter_at" name="at" type="hidden"/>');
      searchBox.append(inputSortUsr, inputCo, inputIn, inputAt);
      $("#nav-search-query").focus(function(event) {
        $("#filter_sort" ).attr("value",$(".j-userSort").val());
        $("#filter_co" ).attr("value",$(".j-userCountry ").val());
        $("#filter_in" ).attr("value",$(".j-userIndustry").val());
        $("#filter_at" ).attr("value",$(".j-userAccount").val());
      });
    }

  },

  /*  Spellcheck pageload handler.
   *  Sends a GA event in case spelling suggestions are returned from the server
   *  The spellcheck functionality is available for turining on/off via rails
   *  app config
   */
  spellcheckPageloadHandler: function(){
    if($(".j-suggested").children().length > 0){
        facetedSearch.trackGA('suggestion_pageload');
    }
  },

  trackhighlighting: function(){
    if(slideshare_object.search && slideshare_object.search.desc_per && slideshare_object.search.desc_hl_per){
      facetedSearch.trackGA('search_pageload', 'Description Percentage', slideshare_object.search.desc_per);
      facetedSearch.trackGA('search_pageload', 'Description HL Percentage', slideshare_object.search.desc_hl_per);
    }
  },

  /*  Wrapper around core google analytics push code
   *  @param  [String]  act The "action" corresponding to GA action param
   *  @param  [String]  label The "label" corr. to GA label param
   *  @param  [Integer] value The "value" corre. to GA value param
   */
  trackGA: function(act,label,value){
    window._gaq = _gaq || [];
    try {
      if (slideshare_object.deploy_environment == 'production') {
        if(act && label && value) {
          _gaq.push(["_trackEvent", ga_category, act, label, value]);
        }
        else if(act && label){
          _gaq.push(["_trackEvent", ga_category, act, label]);
        }
        else if(act){
          _gaq.push(["_trackEvent", ga_category, act]);
        }
      } else {
        if(act && label && value) {
          log(["_trackEvent", ga_category, act, label, value]);
        }
        else if(act && label){
          log(["_trackEvent", ga_category, act, label]);
        }
        else if(act){
          log(["_trackEvent", ga_category, act]);
        }
      }
    } catch(e){}
  },

  /*  Tracks GA for sorting choices. In case of documents, fine drill down to
   *  which filter has been applied is provided, while in case of users'
   *  only main action is available.`
   */
  trackFacetsGA: function() {
    if(facetedSearch.searchType() === "presentations") {
      var lbl = [ $('#slideshows_time').select().val(),
                  $('#slideshows_type').select().val(),
                  $('#slideshows_lang').select().val()
                ].join('_');
      facetedSearch.trackGA("filter_applied",lbl);
    }
    else {
      facetedSearch.trackGA('filter_applied');
    }
  },

  /*  Returns the search tye value (String) based on user selection at UX
   */
  searchType: function() {
    return $("dd.active a").data("searchtype");
  },


  /*  Returns a boolean value signifying the presense of a query string in
   *  search box
   */
  searchQueryExists: function() {
    return ($("#search_query").val() !== "");
  },

  /*  Main submit form handler
   */
  submitForm: function(page_num) {
    if(facetedSearch.searchType() === "presentations") {
      ga_category = 'search_content_filter';
    }
    else {
      ga_category = 'search_people_filter';
    }
    facetedSearch.trackFacetsGA();
    $('#search_form').submit();
    $(".j-searchOverlay").css('height', facetedSearch.getSearchResultsHeight);
    $('.j-searchOverlay').show();
   },

  /*  Handler function for the AJAX search results response. The response has
   *  parsed HTML blocks, which can just be replaced with the existing ones
   */
  resultResponseHandler: function(data){
    $('.j-resultCount').html(data.result_count);
    $('.notice-no-results').hide();
    if(data.search_results.length !== 0){
      $('.notice-no-ajaxy-results').hide();
    }
    else{
      $('.notice-no-ajaxy-results').show();
    }
    $('.j-resultsContainer').html(data.results);
    $('.j-searchOverlay').hide();
    facetedSearch.resizeHandler();
  },

  /*  All the bindings for click action on any DOM element is present inside
   */
  bindClicks: function(){
    var search_infra = $('.j-searchResults').attr('id');
    $("dd.inactive a").click(facetedSearch.switchSearchType);

    //  add binding to every UX element, which when changed upon
    //  should reload the search result
    const ui_selectors = ['#slideshows_sort', '#slideshows_time', '#slideshows_type',
                 '#slideshows_lang', 'input[name="ru"]', '.j-userSort',
                 '.j-userCountry', '.j-userIndustry', '.j-userAccount'];
    $(ui_selectors.join(',')).change(facetedSearch.submitForm);

    // Fire GA upon suggestions click
    $('a.searchSuggestion.ga-track').on('click', function(){
      facetedSearch.trackGA(this.id, 'suggested');
    });

    //  Fire GA on document's thumbnail click
    $('.j-searchResults a.searchResultThumbnail.ga-track').on('click', function(e){
      var ga_action = $(this).data('ga-track-action'),
          act = ga_action + '_' + search_infra,
          act_global = ga_action + '_global';
      facetedSearch.trackGA(act, 'thumbnail');
      facetedSearch.trackGA(act_global, 'thumbnail');
    });

    //  Fire GA on document's Title click
    $('.j-searchResults a.j-slideshow-title').on('click', function(e){
      var ga_action = $(this).data('ga-track-action'),
          act = ga_action + '_' + search_infra,
          act_global = ga_action + '_global';
      facetedSearch.trackGA(act, 'title');
      facetedSearch.trackGA(act_global, 'title');
    });

     // Fire GA on User's Thumbnail click
    $('.j-searchResults a.j-user-thumb').on('click', function(e){
        facetedSearch.trackGA($(this).data('ga-track-action'), 'thumbnail');
    });

    //  Fire GA on User's Name click
    $('.j-searchResults .j-user-name').on('click', function(e){
      facetedSearch.trackGA($(this).data('ga-track-action'), 'name');
    });

    //  Fire event and stop it's propagation by clicking on yellow highlight
    //  ares
    /*-------- Stop the yellow highlight thingy for time being
    $('.j-searchResults li').on('click', function(e){
        if (e.isDefaultPrevented() || e.metaKey || e.ctrlKey) {
            return;
        }
        var curr = $(this).children('.j-url');
        var next_url = curr.attr('href');
        var act = curr.attr('id') + '_' + solr_query_field;
        facetedSearch.trackGA(act, 'yellowarea');
        window.location = next_url;
    });
    */
  },

  /*  Get sponsored results
   */
  getSponsored: function(){
    if ($(".notice-no-results").length === 1) {
      return;
    }
  },

  resizeHandler: function() {
    var slideshowRatio = 225 / 300;
    var $slideshowThumbnails = $(".link-bg-img");
    $slideshowThumbnails.height(Math.floor($slideshowThumbnails.width() * slideshowRatio));
  },

  resizeSelectBox: function(e) {
    $('#hidden_html').html($(e).find('option:selected').text());
    var w = $('#hidden_html').width();
    if (w > 50 && w < 60) {
      $(e).width(65);
    } else {
      $(e).width(w + 8);
    }
  }

};
window.facetedSearch = facetedSearch;

$(document).ready(function(){
  facetedSearch.init();

  // Resize the thumbnails
  $(window).resize(function() { facetedSearch.resizeHandler(); });
  facetedSearch.resizeHandler();

  // Resize the select boxes
  $('select').change(function(){
    facetedSearch.resizeSelectBox(this);
  });

  $('select').each(function(){
    facetedSearch.resizeSelectBox(this);
  });

  // Setup Magellan
  $(document).foundation({
    "magellan-expedition": {
      threshold: $('#main-nav').height(),
      fixed_top: $('#main-nav').height()
    }
    });
  });

})(jQuery);
